@if (station.stationType === stationType.WAITING_AREA) {
  <div>
    <app-waiting-area-details [stationUsage]="station.stationUsage"></app-waiting-area-details>
  </div>
}
@if (station.stationUsage.transports[0] && station.stationType === stationType.WORKING_AREA) {
  <div>
    <!-- Das Sollte mit transports[0] als input zu einer eigenen komponente werden, obacht wegen dem binding!-->
    <app-station-transport-details [sacClientContext]="sacClientContext" [station]="station" [stationSet]="stationSet"
    [transport]="station.stationUsage.transports[0]" [dashboardContext]="dashboardContext"></app-station-transport-details>
  </div>
}